export const PROFILE_IMAGE_WIDTH = 150;
export const PROFILE_IMAGE_HEIGHT = 150;

const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
const MAX_FILE_SIZE_MB = 2;

export const isValidProfileImageSrc = (src) => {
  if (!src || typeof src !== "string") return false;

  const normalized = src.trim().toLowerCase();
  if (!normalized || normalized === "dimension") return false;

  if (
    normalized.startsWith("http") ||
    normalized.startsWith("blob:") ||
    normalized.startsWith("data:") ||
    normalized.startsWith("/")
  ) {
    return true;
  }

  return /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i.test(normalized);
};

export const isRejectedProfileImageValue = (src) =>
  typeof src === "string" && src.trim().toLowerCase() === "dimension";

export const validateProfileImageFile = (file) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("Please select a profile image."));
      return;
    }

    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      reject(new Error("Profile image must be JPG, PNG, or WEBP."));
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      reject(new Error(`Profile image must be smaller than ${MAX_FILE_SIZE_MB}MB.`));
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const { width, height } = img;

      if (width !== PROFILE_IMAGE_WIDTH || height !== PROFILE_IMAGE_HEIGHT) {
        reject(
          new Error(
            `Profile image must be exactly ${PROFILE_IMAGE_WIDTH}x${PROFILE_IMAGE_HEIGHT} pixels. Selected image is ${width}x${height}.`
          )
        );
        return;
      }

      resolve(true);
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Invalid image file."));
    };

    img.src = objectUrl;
  });
